module.exports = __webpack_public_path__ + "static/media/16UNODC23.157bf3d4.jpg";